<template>
  <div
    class="d-flex flex-column flex h-100"
    :style="
      get(getLoggedInUser, 'role_type') === USER_ROLE_TYPES.STUDENT ||
      get(getLoggedInUser, 'role_type') === USER_ROLE_TYPES.SCHOOL
        ? 'min-height: calc(100vh - 350px) !important'
        : ''
    "
  >
    <div v-if="showStdBack" :class="containerClass" class="std-back-row">
      <back-chevron />
    </div>
    <router-view v-bind:layout-props="layoutProps" />
    <swipe-bottom-navigation
      :options="isRoutePublicSchlLanding ? publicRouteOptions : studentRouteOptions"
      v-model="selected"
      swiper-color="var(--primary-color)"
      background-color="#FFFFFF"
      :icon-color="get(getLoggedInUser, 'linked_entity.dark_color') || dark || '#272c33'"
      v-if="
        (get(getLoggedInUser, 'role_type') === USER_ROLE_TYPES.STUDENT || isRoutePublicSchlLanding) && isMobileScreen
      "
      :key="stdNavKey"
    >
      <template #icon="{ props }">
        <md-icon :style="{ color: `${get(getLoggedInUser, 'linked_entity.dark_color', '#272c33')}` || dark }">{{
          props.icon
        }}</md-icon>
      </template>
      <template #title="{ props }">
        <b>{{ props.title }}</b>
      </template>
    </swipe-bottom-navigation>
    <!-- 
    <curved-bottom-navigation
      :options="isRoutePublicSchlLanding ? publicRouteOptions : studentRouteOptions"
      v-model="selected"
      :foreground-color="get(getLoggedInUser, 'linked_entity.dark_color') || dark"
      background-color="#FFFFFF"
      :icon-color="get(getLoggedInUser, 'linked_entity.dark_color') || dark"
      v-if="
        (get(getLoggedInUser, 'role_type') === USER_ROLE_TYPES.STUDENT || isRoutePublicSchlLanding) && isMobileScreen
      "
      :key="stdNavKey"
    >
      <template #icon="{ props }">
        <md-icon>{{ props.icon }}</md-icon>
      </template>
      <template #title="{ props }">
        <b>{{ props.title }}</b>
      </template>
      <template #child-icon="{ props }">
        <md-icon>{{ props.icon }} </md-icon>
      </template>
      <template #child-title="{ props }">
        <div class="pl-2 pr-2">{{ props.title }}</div>
      </template>
    </curved-bottom-navigation> -->
  </div>
</template>

<script>
import {
  SwipeBottomNavigation,
  // SwipeBottomNavigation
} from 'bottom-navigation-vue';
import { get, isEmpty, findIndex } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import { SCH_PUBLIC_PORTAL_LINKS, USER_ROLE_TYPES, DASHBOARD_TYPES } from '@/common/constants';
import BackChevron from '@/components/Ui/BackChevron.vue';
import layoutConfig from '@/mixins/layout-config';

// Student pages with no back chevron: main-menu pages (reached from the top menu, not drilled into)
// and onboarding. TransitionU's menu has more top-level pages than the school/org menu.
const STD_NO_BACK_ROUTES = ['student-dashboard', 'student-onboarding', 'student-info'];
const TU_NO_BACK_ROUTES = ['student-pathways', 'student-advisors'];

export default {
  mixins: [layoutConfig],
  // Layouts nest (e.g. /student -> /student/resources); only the outermost one draws the chevron.
  provide() {
    return { stdBackHost: true };
  },
  inject: { stdBackHost: { default: false } },
  components: {
    BackChevron,
    SwipeBottomNavigation,
    // AppSettings,
  },
  props: {
    layoutProps: {
      type: Object,
    },
  },
  data() {
    return {
      USER_ROLE_TYPES,
      dark: null,
      selected: 1,
      isPaidSchool: null,

      stdNavKey: 'stdRoutes',

      publicRouteOptions: [
        { id: 1, icon: 'school', title: 'For Students', path: { name: 'sch-public-home' } },
        { id: 2, icon: 'business', title: 'For Employers', path: { name: 'sch-public-parnerships' } },
      ],
      windowWidth: window.innerWidth,
    };
  },

  methods: {
    ...mapActions('school', ['getSchoolFromCurrentDomain']),
    ...mapActions('navbarConfig', ['updateNavbarBrandDetails']),
    get,

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },

  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(route) {
        let routeIndex = findIndex(
          this.isRoutePublicSchlLanding ? this.publicRouteOptions : this.studentRouteOptions,
          opt => {
            if (opt.childs && opt.childs.length) {
              return opt.childs.find(childRoute => childRoute.path.name === route.name);
            }
            // Check if route name matches
            if (get(opt, 'path.name') === route.name) {
              // For category-detail routes, also check params
              if (route.name === 'category-detail' && opt.path.params) {
                return opt.path.params.categoryType === route.params.categoryType;
              }
              return true;
            }
            return false;
          },
        );
        if (routeIndex > -1) {
          this.selected = routeIndex + 1;
        }
      },
    },

    studentRouteOptions: {
      immediate: true,
      handler(value) {
        let routeIndex = findIndex(
          this.isRoutePublicSchlLanding ? this.publicRouteOptions : this.studentRouteOptions,
          opt =>
            opt.childs && opt.childs.length
              ? opt.childs.find(route => route.path.name === value)
              : get(opt, 'path.name') === value,
        );
        if (routeIndex > -1) {
          this.selected = routeIndex + 1;
        }
      },
    },

    getPaymentStatus: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value) {
          this.isPaidSchool = value;
          this.stdNavKey = 'stdPremRoutes';

          // this.$nextTick(() => {
          //   let routeIndex = findIndex(
          //     this.studentPremiumRouteOptions,
          //     (opt) => get(opt, 'path.name') === this.$route.name
          //   );
          //   if (routeIndex !== -1) this.selected = routeIndex + 1;
          // });
        }
      },
    },
  },

  created() {
    if (this.isSchoolDashboard) {
      this.selected = 1;
    }
  },

  async mounted() {
    window.addEventListener('resize', this.handleResize);
    // if (
    //   get(this.getLoggedInUser, 'role_type') === USER_ROLE_TYPES.STUDENT ||
    //   get(this.getLoggedInUser, 'role_type') === USER_ROLE_TYPES.SCHOOL
    // ) {
    //   const school = await this.updateNavbarBrandDetails();
    // }

    try {
      const school = await this.getSchoolFromCurrentDomain({ storeSchool: true });
      if (!isEmpty(school)) {
        this.$store.commit('school/updateCurrentSchool', school);
        this.dark = school.dark_color;
      }
    } catch (error) {
      // Silently handle error for superadmin who doesn't have a school subdomain
      console.log('No school subdomain found (expected for superadmin)');
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    isTuMenuPage() {
      const isEducation = this.$route.name === 'category-detail' && this.$route.params.categoryType === 'education';
      return isEducation || TU_NO_BACK_ROUTES.includes(this.$route.name);
    },
    showStdBack() {
      return (
        !this.stdBackHost &&
        get(this.getLoggedInUser, 'role_type') === USER_ROLE_TYPES.STUDENT &&
        !this.isRoutePublicSchlLanding &&
        !STD_NO_BACK_ROUTES.includes(this.$route.name) &&
        !(this.getLoggedInUserDashboard === DASHBOARD_TYPES.CARECAMPUS && this.isTuMenuPage)
      );
    },
    ...mapGetters('auth', ['getLoggedInUser', 'getLoggedInUserDashboard']),
    ...mapGetters('school', ['getPaymentStatus']),

    isSchoolDashboard() {
      return this.getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL;
    },

    schoolCategoryRouteOptions() {
      return [
        {
          id: 1,
          icon: 'home',
          title: 'Home',
          path: { name: 'student-dashboard' },
        },
        {
          id: 2,
          icon: 'school',
          title: 'Academic',
          path: { name: 'category-detail', params: { categoryType: 'academic' } },
        },
        {
          id: 3,
          icon: 'work_outline',
          title: 'Opportunities',
          path: { name: 'category-detail', params: { categoryType: 'career_opportunities' } },
        },
        {
          id: 4,
          icon: 'trending_up',
          title: 'Preparation',
          path: { name: 'category-detail', params: { categoryType: 'career_preparation' } },
        },
        {
          id: 5,
          icon: 'folder',
          title: 'Resources',
          path: { name: 'student-community' },
        },
      ];
    },

    isRoutePublicSchlLanding() {
      return SCH_PUBLIC_PORTAL_LINKS.includes(this.$route.name);
    },
    isMobileScreen() {
      return this.windowWidth <= 575;
    },

    careerPathRoutes() {
      return get(this.getLoggedInUser, 'linked_entity.std_portal_uni')
        ? {
            id: 4,
            icon: 'local_hospital',
            title: 'Pathways',
            childs: [
              { id: 301, icon: 'business_center', title: 'Orgs', path: { name: 'student-org-listing' } },
              { id: 302, icon: 'account_balance', title: 'Unis', path: { name: 'student-uni-listing' } },
            ],
          }
        : {
            id: 4,
            icon: 'local_hospital',
            title: 'Career Paths',
            path: { name: 'student-org-listing' },
          };
    },

    studentPremiumRouteOptions() {
      return [
        { id: 1, icon: 'home', title: 'Home', path: { name: 'student-dashboard' } },

        // Replaced with Community page
        // { id: 2, icon: 'question_answer', title: 'Questions', path: { name: 'student-questions' } },
        // { id: 3, icon: 'videocam', title: 'Skills', path: { name: 'student-skill' } },

        {
          id: 2,
          icon: 'work',
          title: 'Jobs',
          childs: [
            { id: 356, icon: 'business_center', title: 'All', path: { name: 'student-jobs-listing' } },
            { id: 357, icon: 'account_balance', title: 'Featured', path: { name: 'student-local-jobs-listing' } },
            { id: 358, icon: 'business', title: 'Companies', path: { name: 'student-employers-list' } },
          ],
        },
        { id: 3, icon: 'stars', title: 'Sponsorships', path: { name: 'student-scholarships-listing' } },
        // { id: 4, icon: 'business', title: 'Companies', path: { name: 'student-employers-list' } },
        this.careerPathRoutes,

        // { id: 6, icon: 'apps', title: 'Resources', path: { name: 'student-community' } },
      ];
    },

    studentRouteOptions() {
      if (this.isSchoolDashboard) {
        return this.schoolCategoryRouteOptions;
      }

      if (this.getLoggedInUserDashboard === DASHBOARD_TYPES.CARECAMPUS) {
        return [
          { id: 1, icon: 'home', title: 'Home', path: { name: 'student-dashboard' } },
          { id: 2, icon: 'trending_up', title: 'Paths', path: { name: 'student-pathways' } },
          { id: 3, icon: 'people', title: 'Mentors', path: { name: 'student-advisors' } },
          {
            id: 4,
            icon: 'school',
            title: 'Education',
            path: { name: 'category-detail', params: { categoryType: 'education' } },
          },
          { id: 6, icon: 'info', title: 'My Info', path: { name: 'student-info' } },
        ];
      }

      return [
        { id: 1, icon: 'home', title: 'Home', path: { name: 'student-dashboard' } },
        { id: 3, icon: 'info', title: 'My Info', path: { name: 'student-info' } },
        // { id: 4, icon: 'assignment_ind', title: 'Advisors', path: { name: 'student-advisors' } },
        // ...(this.getLoggedInUserDashboard === DASHBOARD_TYPES.ORGANIZATION
        //   ? [{ id: 5, icon: 'search', title: 'Explore', path: { name: 'student-community' } }]
        //   : []),
      ];
    },
  },
};
</script>

<style>
.std-back-row {
  padding-top: 20px;
  margin-bottom: 0;
}
/* The page under the chevron always starts the same distance below it, whatever padding its root carries. */
.std-back-row + .page-section,
.std-back-row + .tu-scope {
  padding-top: 14px !important;
}
</style>
